import { Analytics } from "@vercel/analytics/react";
import type { AppProps } from "next/app";
import "../styles/globals.css";
export { reportWebVitals } from 'next-axiom';
import { CookiesProvider } from "react-cookie";
import { appWithTranslation } from 'next-i18next';
import { GoogleAnalytics } from "nextjs-google-analytics";
import { SessionProvider } from "next-auth/react"

function MyApp({ Component, pageProps: { session, ...pageProps }, }: AppProps) {  


  return (
    <SessionProvider
      session={session}
      refetchOnWindowFocus={false}
      refetchWhenOffline={false}
      refetchInterval={0}
    >
    <CookiesProvider>
      <GoogleAnalytics trackPageViews />
      <Component {...pageProps} />       
       <Analytics />
    </CookiesProvider>
    </SessionProvider>
  );
}

export default appWithTranslation(MyApp); //nextI18nConfig

//export default appWithTranslation(MyApp);
